import {
  setCheckButtons,
  setTableButtons,
  setFormButtons,
  getCardFormHeadButtons
} from '@/utils/getbuttons.js'

const enterprise = {
  enterprise: {
    name: 'enterprise',
    theme: '企业信息',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'cardForm',
      'collapses',
      'dialogForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'enterprise/getEnterpriseList',
    deleteFun: 'enterprise/deleteEnterprise',
    getDetailFun: 'enterprise/getEnterpriseInfo',
    detailPage: [
      {
        buttonName: '新增',
        type: 'cardForm',
        name: 'enterprise',
        theme: 'enterprise',
        step: 'enterpriseInfo',
        label: '新增企业档案'
      },
      {
        buttonName: '编辑',
        type: 'cardForm',
        name: 'enterprise',
        theme: 'enterprise',
        step: 'enterpriseInfo',
        label: '编辑企业档案',
        checkType: 'checkByUid',
        checkFun: 'enterprise/getEnterpriseInfo'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    rowKey: 'orgUid',
    subcomponents: [
      'baseInfo',
      'attachment',
      'certificate',
      'enterpriseRecord'
    ],
    cardFormNames: ['baseInfo', 'attachment'],
    collapsesNames: ['certificate', 'enterpriseRecord'],
    queryParams: {
      query: ''
    },
    selectData: [
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '企业名称/法人/联系人/注册地'
      }
    ],
    hasPagination: true,
    rowData: (params) => {
      return params.state.enterprise.enterpriseList.result
    },
    rowTotal: (params) => {
      return params.state.enterprise.enterpriseList.totalSize
    },
    columns: [
      { prop: 'orgName', label: '企业名称', width: '360px', overflow: false, tooltip: { tipKey: 'formerName', tipLabel: '曾用名：' } },
      { prop: 'registerPlace', label: '注册地', width: '460px' },
      { prop: 'legalPersonName', label: '法人', width: '' },
      { prop: 'contact', label: '联系人', width: '' },
      { prop: 'contactTel', label: '联系电话', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除', '二维码']),
        width: '260px'
      }
    ],
    baseInfo: {
      addFun: 'enterprise/addEnterprise',
      editFun: 'enterprise/editEnterprise',
      getDetailFun: 'enterprise/getEnterpriseBaseInfo',
      formParams: {
        uid: '',
        name: '',
        formerName: '',
        creditCode: '',
        parentCompany: '',
        unitNature: '',
        registerPlace: '',
        registerPlaceCode: '',
        postalCode: '',
        legalPersonName: '',
        legalPersonTel: '',
        legalPersonCarnum: '',
        currency: '',
        registeredCapital: '',
        establishmentDate: '',
        contact: '',
        contactTel: ''
      },
      formRules: {
        name: [
          {
            required: true,
            message: '请输入企业名称',
            trigger: 'blur'
          }
        ],
        legalPersonTel: [
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '手机号码输入不合法',
            trigger: 'blur'
          }
        ],
        contact: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur'
          }
        ],
        contactTel: [
          {
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '手机号码输入不合法',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          card: '基础信息',
          formerNameKind: 'enterprise',
          cardTip: (params) => {
            if (params.pageStatus === 'complete') {
              return '提示：已有信息只读显示；仅缺失项可补全后保存。资质证书、附件等已有记录不可编辑删除，新办或进场后新增的才可编辑删除。'
            }
            return params.pageStatus === 'outsideCheck'
              ? '提示：如果该企业还未进场你的机构，法人身份证、营业执照等敏感信息将不可查看。'
              : ''
          },
          headButtons: getCardFormHeadButtons(0),
          fields: [
            {
              key: 'name',
              label: '企业名称',
              type: 'input',
              placeholder: '请输入全称认证查询信息',
              inputButton: '认证',
              buttonIcon: 'el-icon-search'
            },
            {
              key: 'creditCode',
              label: '统一社会信用代码',
              type: 'input'
            },
            {
              key: (params) => {
                return params.pageStatus === 'add' ||
                  params.pageStatus === 'edit' ||
                  params.pageStatus === 'complete'
                  ? 'parentCompany'
                  : 'parentEnterprise'
              },
              label: '父级企业',
              type: 'select',
              placeholder: '选填，可在组织结构中关联',
              filterable: true,
              clearable: true,
              remote: true, // 关键词远程搜索
              options: (params) => {
                return params.state.enterprise.enterprises
              },
              checkByValue: true
            },
            {
              key: 'unitNature',
              label: '单位性质',
              type: 'select',
              options: (params) => {
                return params.dictionarys.unitNature
              }
            },
            {
              key: 'registerPlace',
              label: '注册地',
              type: 'input'
            },
            {
              key: 'registerPlaceCode',
              label: '注册地区编码',
              type: 'input'
            },
            {
              key: 'postalCode',
              label: '邮政编码',
              type: 'input'
            },
            {
              key: 'legalPersonName',
              label: '法人姓名',
              type: 'input'
            },
            {
              key: 'legalPersonTel',
              label: '法人电话',
              type: 'input'
            },
            {
              key: 'legalPersonCarnum',
              label: '法人身份证号',
              type: 'input'
            },
            {
              key: 'currency',
              label: '注册资本币种',
              type: 'input'
            },
            {
              key: 'registeredCapital',
              label: '注册资本',
              type: 'input',
              inputButton: '万元'
            },
            {
              key: 'establishmentDate',
              label: '成立日期',
              type: 'time'
            },
            {
              key: 'contact',
              label: '联系人',
              type: 'input'
            },
            {
              key: 'contactTel',
              label: '联系电话',
              type: 'input'
            }
          ]
        }
      ]
    },
    attachment: {
      outsideCheck: (params) => {
        return params.pageStatus !== 'outsideCheck'
      },
      editFun: 'enterprise/editEnterprise',
      getDetailFun: 'enterprise/getEnterpriseAttachment',
      formParams: {
        uid: '',
        businessPerfUid: '',
        safeProductPhoto: '',
        otherPhoto: [],
        fileLists: {
          businessPerfUid: [],
          safeProductPhoto: [],
          otherPhoto: []
        }
      },
      formRules: {
        businessPerfUid: [
          {
            required: true,
            message: '请上传营业执照',
            trigger: 'blur'
          }
        ],
        safeProductPhoto: [
          {
            required: true,
            message: '请上传安全生产证',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          card: '附件信息',
          manualUpload: true,
          headButtons: getCardFormHeadButtons(1),
          fields: [
            {
              key: 'businessPerfUid',
              label: '营业执照',
              type: 'upload',
              autoUpload: false,
              limit: 1,
              span: 4
            },
            {
              key: 'safeProductPhoto',
              label: '安全生产证',
              type: 'upload',
              autoUpload: false,
              limit: 1,
              span: 4
            },
            {
              key: 'otherPhoto',
              label: '其他附件',
              type: 'upload',
              autoUpload: false,
              limit: 5,
              span: 16
            }
          ]
        }
      ]
    },
    certificate: {
      card: '资质证书',
      modifiable: true,
      manualUpload: true,
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增资质证书'
          : params.pageStatus === 'edit'
          ? '编辑资质证书'
          : ''
      },
      headButtons: setFormButtons(['新增']),
      detailPage: [
        {
          buttonName: '新增',
          type: 'dialogForm',
          name: 'certificate'
        },
        {
          buttonName: '编辑',
          type: 'dialogForm',
          name: 'certificate',
          checkType: 'useRowData'
        }
      ],
      deleteFun: 'enterprise/deleteCertificate',
      getListFun: 'enterprise/getCertificates',
      addFun: 'enterprise/addCertificate',
      editFun: 'enterprise/editCertificate',
      collapsesTitleImg: '#icon-tubiaozhizuomoban-',
      collapsesTitle: [
        { key: 'certificateName', type: 'text' },
        { key: 'statusIcon', type: 'icon' },
        { key: 'certificateStatus', type: 'text' }
      ],
      collapsesList: (params) => {
        return params.state.enterprise.certificate
      },
      collapsesData: [
        {
          key: 'certificateName',
          label: '证书名称',
          collapseType: 'text'
        },
        {
          key: 'certificateType',
          label: '证书类型',
          collapseType: 'text'
        },
        {
          key: 'certificateNum',
          label: '证书编号',
          collapseType: 'text'
        },
        {
          key: 'startTime',
          label: '有效起始日期',
          collapseType: 'text'
        },
        {
          key: 'endTime',
          label: '有效截止日期',
          collapseType: 'text'
        },
        {
          key: 'grantTime',
          label: '最近发放日期',
          collapseType: 'text'
        },
        {
          key: 'qualificationsStatus',
          label: '资质状态',
          collapseType: 'text'
        },
        {
          key: 'certificateStatus',
          label: '资质证书状态',
          collapseType: 'text'
        },
        {
          key: 'photoUid',
          label: '证书照片',
          collapseType: 'popover'
        }
      ],
      formParams: {
        uid: '',
        companyUid: (params) => {
          return params.state.currentUids.enterprise
        },
        certificateName: '',
        certificateType: '',
        certificateNum: '',
        startTime: '',
        endTime: '',
        grantTime: '',
        qualificationsStatus: '',
        certificateStatus: '',
        photoUid: '',
        fileLists: {
          photoUid: []
        }
      },
      formRules: {
        certificateName: [
          {
            required: true,
            message: '请输入证书名称',
            trigger: 'blur'
          }
        ],
        certificateType: [
          {
            required: true,
            message: '请选择证书类型',
            trigger: 'blur'
          }
        ],
        certificateNum: [
          {
            required: true,
            message: '请输入证书编号',
            trigger: 'blur'
          }
        ],
        startTime: [
          {
            required: true,
            message: '请选择有效起始日期',
            trigger: 'blur'
          }
        ],
        endTime: [
          {
            required: true,
            message: '请选择有效截止日期',
            trigger: 'blur'
          }
        ],
        qualificationsStatus: [
          {
            required: true,
            message: '请选择资质状态',
            trigger: 'blur'
          }
        ],
        certificateStatus: [
          {
            required: true,
            message: '请选择资质证书状态',
            trigger: 'blur'
          }
        ],
        photoUid: [
          {
            required: true,
            message: '请上传证书图片',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'certificateName',
          label: '证书名称',
          type: 'input'
        },
        {
          key: 'certificateType',
          label: '证书类型',
          type: 'cascader',
          options: (params) => {
            return params.dictionarys.certificateType
          },
          checkByValue: true,
          emitPath: false
        },
        {
          key: 'certificateNum',
          label: '证书编号',
          type: 'input',
          placeholder: '请输入证书编号'
        },
        {
          key: 'startTime',
          label: '有效起始日期',
          type: 'time'
        },
        {
          key: 'endTime',
          label: '有效截止日期',
          type: 'time'
        },
        {
          key: 'grantTime',
          label: '最近发放日期',
          type: 'time'
        },
        {
          key: 'qualificationsStatus',
          label: '资质状态',
          type: 'select',
          options: (params) => {
            return params.dictionarys.funStatus
          }
        },
        {
          key: 'certificateStatus',
          label: '资质证书状态',
          type: 'select',
          options: (params) => {
            return params.dictionarys.cerStatus
          }
        },
        {
          key: 'photoUid',
          label: '证书照片',
          type: 'upload',
          autoUpload: false,
          limit: 1,
          span: 24
        }
      ]
    },
    enterpriseRecord: {
      outsideCheck: (params) => {
        return params.pageStatus !== 'add'
      },
      card: '项目业绩',
      collapsesTitleImg: '#icon-01',
      collapsesTitle: [
        { key: 'titleText', type: 'text' },
        { key: 'typeIcon', type: 'icon' },
        { key: 'orgType', type: 'text' }
      ],
      collapsesList: (params) => {
        return params.state.enterprise.enterpriseRecord
      },
      collapsesData: [
        {
          key: 'orgName',
          label: '项目名称',
          collapseType: 'text'
        },
        {
          key: 'orgType',
          label: '参建类型',
          collapseType: 'text'
        },
        {
          key: 'orgBeginTime',
          label: '进场日期',
          collapseType: 'text'
        },
        {
          key: 'walkoffDate',
          label: '退场日期',
          collapseType: 'text'
        },
        {
          key: 'leaderName',
          label: '负责人',
          collapseType: 'text'
        },
        {
          key: 'leaderPhone',
          label: '负责人电话',
          collapseType: 'text'
        },
        {
          key: 'maxUserNum',
          label: '最大用工数量',
          collapseType: 'text'
        },
        {
          key: 'workContent',
          label: '参建职责',
          collapseType: 'text'
        },
        {
          key: 'companyEvaluation',
          label: '公司考评',
          collapseType: 'text'
        }
      ]
    }
  }
}

export default enterprise
